import Vue from 'vue';
import App from './App.vue';
import router from './router';
import mixins from './mixins';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/reset.css';
import '@/assets/style/common.less';
import EPageination from './components/EPageination.vue';
import MainContent from '@/components/MainContent.vue';
import EDialog from '@/components/EDialog.vue';
import EDialogTips from '@/components/EDialogTips.vue';
import EDrawer from '@/components/EDrawer.vue';
import EUploadAvator from '@/components/EUploadAvator.vue';
import store from './store';
import {hasAuth} from '@/directives/auth';

// 方法
Vue.prototype.$hasAuth = hasAuth;

// 自定义指令
import auth from '@/directives/auth';
Vue.directive('auth', auth);

Vue.config.productionTip = false;
Vue.mixin(mixins);
// 方法库
Vue.use(ElementUI);
Vue.component('MainContent', MainContent);
Vue.component('EPageination', EPageination);
Vue.component('EDialog', EDialog);
Vue.component('EDialogTips', EDialogTips);
Vue.component('EDrawer', EDrawer);
Vue.component('EUploadAvator', EUploadAvator);
new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
